<template>
  <section class="bg-white rounded table-section mt-5">
    <ejs-grid
      v-show="!showLoader"
      ref="dataGrid"
      :created="refreshGrid"
      :allowPaging="true"
      :allowSorting="true"
      :pageSettings="pageSettings"
      :toolbar="toolbar"
      :searchSettings="search"
      :allowExcelExport="true"
      :allowPdfExport="true"
      :toolbarClick="toolbarClick"
      :locale="usedLang"
    >
      <e-columns>
        <e-column width="40" field="index" headerText="#"></e-column>

        <e-column
          field="branchName"
          width="180"
          :headerText="$t('text.iGenerators.site')"
        ></e-column>
        <e-column
          field="startedDate"
          width="180"
          :headerText="$t('text.iGenerators.startedDate')"
        ></e-column>
        <e-column
          field="totalHour"
          width="180"
          :headerText="$t('text.iGenerators.totalHours')"
        ></e-column>
        <e-column
          field="expectedDays"
          width="180"
          :headerText="$t('text.iGenerators.daysToMaintenance')"
        ></e-column>
      </e-columns>
    </ejs-grid>
    <TableLoader :showLoader="showLoader" />
  </section>
</template>

<script>
import AdminMasterLayout from "@/views/Industrial/AdminMasterLayout.vue";
import TableLoader from "@/components/tableLoader/index";
import configObject from "@/config";
import OrderActions from "@/components/TableTemplates/IndustrialAdmin/orderMGT.vue";

import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-vue-grids";

export default {
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      showLoader: true,
      companyID: localStorage.getItem("companyID")
        ? localStorage.getItem("companyID")
        : null,
      dateRange: { start: this.pluginStartDate, end: this.pluginEndDate },

      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      pageSettings: { pageSizes: [12, 50, 100, 200], pageCount: 4 },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
      orderAction: function () {
        return {
          template: OrderActions,
        };
      },
    };
  },
  components: {
    AdminMasterLayout,
    TableLoader,
  },
  created() {
    this.getGenerators();
  },
  methods: {
    getGenerators() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Industrial/Company/NextServiceDay/${this.companyID}`,
          configObject.authConfig()
        )
        .then((res) => {
          this.showLoader = false;
          // console.log(res.data);
          let index = 0;
          res.data.forEach((el) => {
            index++;
            el.index = index;
            el.startedDate = new Date(el.startedDate).toDateString();
            el.totalHour = el.totalHour.toLocaleString(undefined, {
              maximumFractionDigits: 2,
              minimumFractionDigits: 2,
            });
            el.expectedDays = Math.ceil(el.expectedDays);
          });
          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: res.data,
          });
          // console.log(res);
        });
    },

    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },

    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
  },
};
</script>

<style scoped>
.wallet-header {
  width: 90%;
  margin: auto auto;
}

.overhead h5 {
  color: #2b2b2b;
  font-size: 35px;
}

.overhead ul {
  list-style: none;
  padding: 0;
  margin: 0;
  width: 92%;
  margin: auto auto;
}

.sub-nav li {
  color: #2b2b2b;
  font-size: 14px;
  cursor: pointer;
}

.active-nav {
  color: #370f70 !important;
  border-bottom: 2px solid #370f70;
}

.sub-nav {
  width: 98%;
  margin: auto auto;
  border-bottom: 1px solid rgba(98, 98, 98, 0.2);
}

.table-section {
  width: 95%;
  margin: auto auto;
  height: 400px;
}

@media only screen and (max-width: 600px) {
  .new_card {
    display: block;
    width: 100%;
  }
  .first-section {
    flex-direction: column;
  }
}
</style>
